export default ['loan_request.amount'];
